import { orderBy } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { Link } from '@dndbeyond/character-common-components/es';
import {
    CharacterAvatarPortrait,
    DarkPlayButtonSvg,
    FeatureFlagContext,
    HtmlContent,
} from '@dndbeyond/character-components/es';
import {
    CampaignCharacterContract,
    CampaignDataContract,
    CampaignUtils,
    Constants,
    rulesEngineSelectors,
} from '@dndbeyond/character-rules-engine/es';

import { SidebarHeader } from '../../../components/Sidebar';
import * as appEnvSelectors from '../../../selectors/appEnv';
import { SharedAppState } from '../../../stores/typings';
import { NavigationUtils } from '../../../utils';

interface Props {
    campaign: CampaignDataContract;
    currentCharacterId: number;
    isReadonly: boolean;
}
class CampaignPane extends React.PureComponent<Props> {
    render() {
        const { campaign, currentCharacterId, isReadonly } = this.props;

        const link = CampaignUtils.getLink(campaign);
        const characters = CampaignUtils.getCharacters(campaign);
        const dmUsername = CampaignUtils.getDmUsername(campaign);
        const name = CampaignUtils.getName(campaign);
        const description = CampaignUtils.getDescription(campaign);

        let filteredCharacters: Array<CampaignCharacterContract> = characters
            ? characters.filter((character) => character.privacyType === Constants.PreferencePrivacyTypeEnum.PUBLIC)
            : [];
        let orderedCharacters: Array<CampaignCharacterContract> = orderBy(
            filteredCharacters,
            (character: CampaignCharacterContract) => character.characterName,
        );

        let campaignNameNode: React.ReactNode;
        if (isReadonly) {
            campaignNameNode = <div className="ct-campaign-pane__name">{name}</div>;
        } else {
            campaignNameNode = (
                <a className="ct-campaign-pane__name-link" href={link ? link : ''}>
                    {name}
                </a>
            );
        }

        return (
            <div className="ct-campaign-pane">
                <div className="ct-campaign-pane__header">
                    <SidebarHeader>Campaign</SidebarHeader>
                    <FeatureFlagContext.Consumer>
                        {(ffm) =>
                            ffm.getFlag(ffm.FLAGS.RELEASE_GATE_TACTICAL_MAPS) && (
                                <Link url={NavigationUtils.getLaunchGameUrl(campaign)} target="maps">
                                    <div className="ct-character-header-desktop__button ct-theme-button--filled ct-button">
                                        <div className="ct-character-header-desktop__button-icon">
                                            <DarkPlayButtonSvg />
                                        </div>
                                        <span className="ct-character-header-desktop__button-label">Launch Game</span>
                                    </div>
                                </Link>
                            )
                        }
                    </FeatureFlagContext.Consumer>
                </div>
                <div className="ct-campaign-pane__name">{campaignNameNode}</div>
                {!isReadonly && description !== null && (
                    <HtmlContent className="ct-campaign-pane__description" html={description} />
                )}
                <div className="ct-campaign-pane__dm">
                    <span className="ct-campaign-pane__dm-label">DM:</span>
                    <span className="ct-campaign-pane__dm-user">{dmUsername}</span>
                </div>
                <div className="ct-campaign-pane__characters">
                    {orderedCharacters.map((character: CampaignCharacterContract) => {
                        let classNames: Array<string> = ['ct-campaign-pane__character'];
                        let nameNode: React.ReactNode;
                        if (currentCharacterId === character.characterId) {
                            classNames.push('ct-campaign-pane__character--active');
                            nameNode = (
                                <span className="ct-campaign-pane__character-name-text">{character.characterName}</span>
                            );
                        } else {
                            nameNode = (
                                <a
                                    href={character.characterUrl ? character.characterUrl : ''}
                                    className="ct-campaign-pane__character-name-link"
                                >
                                    {character.characterName}
                                </a>
                            );
                        }

                        return (
                            <div className={classNames.join(' ')} key={character.characterId}>
                                <CharacterAvatarPortrait className={'ct-campaign-pane__character-preview'} avatarUrl={character.avatarUrl} />
                                <div className="ct-campaign-pane__character-content">
                                    <div className="ct-campaign-pane__character-name">{nameNode}</div>
                                    <div className="ct-campaign-pane__character-user">{character.username}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {
        campaign: rulesEngineSelectors.getCampaign(state),
        currentCharacterId: appEnvSelectors.getCharacterId(state),
        isReadonly: appEnvSelectors.getIsReadonly(state),
    };
}

export default connect(mapStateToProps)(CampaignPane);
